"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAESubServices = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

var _FAESubService = require("../FAESubService/FAESubService");

require("./FAESubServices.scss");

const _excluded = ["subServices", "justify", "align", "className", "border", "loading", "loaderProps", "shadowBoxProps", "onClick"],
      _excluded2 = ["src", "alt", "name", "price", "discountedPrice", "currencySymbol", "shortDescription"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAESubServices = _ref => {
  let {
    subServices = [],
    justify,
    align,
    className = "",
    border,
    loading,
    loaderProps,
    shadowBoxProps,
    onClick: _onClick = () => {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--sub-services-wrapper ".concat(className)
  }, rest), subServices.map((subIndustry, index) => {
    const {
      src,
      alt,
      name,
      price,
      discountedPrice,
      currencySymbol,
      shortDescription
    } = subIndustry,
          rest = _objectWithoutProperties(subIndustry, _excluded2);

    return /*#__PURE__*/_react.default.createElement(_FAESubService.FAESubService, _extends({
      key: index,
      src: src,
      alt: alt,
      name: name,
      price: price,
      shortDescription: shortDescription,
      currencySymbol: currencySymbol,
      discountedPrice: discountedPrice,
      border: border,
      shadowBoxProps: shadowBoxProps,
      onClick: () => _onClick(subIndustry)
    }, rest));
  })));
};

exports.FAESubServices = FAESubServices;